import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = () => {
  // Organization Schema (as requested)
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Equi Pulse Research",
    "url": "https://www.equipulseresearch.com",
    "logo": "https://www.equipulseresearch.com/logo.png",
    "description": "SEBI Registered Research Analyst providing stock market research and equity analysis",
    "sameAs": [
      "https://www.facebook.com/profile.php?id=61585181202845",
      "https://www.linkedin.com/in/equi-pulse-092280373/",
      "https://www.instagram.com/equipulse1"
    ]
  };

  // ProfessionalService Schema (as requested)
  const professionalServiceSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Equi Pulse Research",
    "description": "SEBI Registered Research Analyst",
    "url": "https://www.equipulseresearch.com",
    "areaServed": "IN",
    "serviceType": "Financial Research and Analysis"
  };

  // FinancialService Schema (detailed)
  const financialServiceSchema = {
    "@context": "https://schema.org",
    "@type": "FinancialService",
    "name": "Equi Pulse Research",
    "alternateName": "Equi Pulse",
    "url": "https://www.equipulseresearch.com",
    "logo": "https://www.equipulseresearch.com/logo.png",
    "image": "https://www.equipulseresearch.com/og-image.png",
    "description": "SEBI-registered research analyst (INH000024046) providing data-driven equity research, stock market advisory, and investment insights for Indian investors.",
    "email": "care@equipulseresearch.com",
    "telephone": "+91-8982892301",
    "priceRange": "₹₹",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "RE-54, Gyansila City, Dhabli",
      "addressLocality": "Indore",
      "addressRegion": "Madhya Pradesh",
      "postalCode": "453771",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 22.7196,
      "longitude": 75.8577
    },
    "sameAs": [
      "https://www.facebook.com/profile.php?id=61585181202845",
      "https://www.instagram.com/equipulse1",
      "https://t.me/equipulse",
      "https://x.com/equi_pulse",
      "https://www.linkedin.com/in/equi-pulse-092280373/"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-8982892301",
      "contactType": "customer service",
      "email": "care@equipulseresearch.com",
      "availableLanguage": ["English", "Hindi"]
    },
    "founder": {
      "@type": "Person",
      "name": "Siddharth Sharma"
    },
    "areaServed": {
      "@type": "Country",
      "name": "India"
    }
  };

  // BreadcrumbList Schema
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.equipulseresearch.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Services",
        "item": "https://www.equipulseresearch.com/services"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Pricing",
        "item": "https://www.equipulseresearch.com/pricing"
      },
      {
        "@type": "ListItem",
        "position": 4,
        "name": "About Us",
        "item": "https://www.equipulseresearch.com/about"
      },
      {
        "@type": "ListItem",
        "position": 5,
        "name": "Contact",
        "item": "https://www.equipulseresearch.com/contact"
      }
    ]
  };

  return (
    <Helmet>
      {/* Organization Schema */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      {/* ProfessionalService Schema */}
      <script type="application/ld+json">
        {JSON.stringify(professionalServiceSchema)}
      </script>
      {/* FinancialService Schema */}
      <script type="application/ld+json">
        {JSON.stringify(financialServiceSchema)}
      </script>
      {/* Breadcrumb Schema */}
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
